import { useQuery } from "urql"
import type { CombinedError } from "urql"

import "../graphql/glTransaction.query"

import { GetGlTransactionDocument, type GlTransaction } from "@/graphql/codegen/graphql"

export interface UseGetGlTransactionReturn {
  glTransaction: GlTransaction | null
  isFetching: boolean
  error: CombinedError | undefined
}

export const useGetGlTransaction = (glTransactionId: string): UseGetGlTransactionReturn => {
  const [{ data, fetching, error }] = useQuery({
    query: GetGlTransactionDocument,
    variables: { input: { glTransactionId } },
    requestPolicy: "network-only",
  })

  const glTransaction =
    data?.glTransaction.get.__typename === "GlTransactionGetSuccess" ? data.glTransaction.get.glTransaction : null

  return { glTransaction, isFetching: fetching, error }
}
